import CompareFundsComponent from './CompareFundsContainer';

export default CompareFundsComponent;
